import { z } from "zod";
const DeliveryLocationDrawerDataSchema = z.object({
  /** Aria label of drawer back button. */
  backButtonAriaLabel: z.string(),
  /** Aria label of drawer close button. */
  closeButtonAriaLabel: z.string(),
  /** Description of the Drawer. */
  description: z.string().optional(),
  /** Description of the Drawer. Used only if National Delivery is enabled for that warehouse */
  NDEnabledDescription: z.string().optional(),
  confirmationTemplate: z.string().optional(),
  /** Title of the text input. */
  inputTitle: z.string().optional(),
  /** Error message when text input contains an invalid value. */
  invalidInputErrorMessage: z.string().optional(),
  /** Error message when geoLocation service is down. */
  serviceDownErrorMessage: z.string().optional(),
  /** Message to tell user to add zip+4 or enter full delivery address */
  enterFullDeliveryAddress: z.string().optional(),
  /** Title of the Drawer. */
  title: z.string(),
  /** Subtitle of the Drawer. */
  drawerSubtitle: z.string().optional(),
  /** Validation Schema to use for the text input. */
  validationSchemaType: z.enum(["en-us", "en-ca", "fr-ca"]),
  /** Help Text */
  helperText: z.string().optional(),
  /** Primary Button Label */
  buttonLabel: z.string(),
  /** Error message shown when delivery for given zip code is not available */
  deliveryNotAvailable: z.string().optional(),
  /** Error message shown when delivery for given zip code is not available and a segmented restricted zip*/
  deliveryToLimitedAreas: z.string().optional(),
  /** Street Address input label  */
  streetAddressInputLabel: z.string().optional(),
  /** Apartment, suite, unit, etc input label  */
  aptSuiteUnitEtcInputField: z.string().optional(),
  /** Zipcode input label */
  zipcodeInputLabel: z.string().optional(),
  /** Error for when no match was found for address */
  errorNoMatchForAddress: z.string().optional(),
  /** Error for when service is down */
  serviceError: z.string().optional(),
  /** Textfield Optional Label Text */
  optionalLabelText: z.string().optional(),
  /** Address line 1 text label */
  addressLine1LabelText: z.string().optional(),
  /** Address line 2 text label */
  addressLine2LabelText: z.string().optional(),
  /** Error Message input valid Address */
  errorMsgInputValidAddrText: z.string().optional(),
  /** Error Message input valid Zipcode */
  errorMsgInputValidZipCodeText: z.string().optional()
});
const ErrorSchema = z.object({
  errorConfig: z.object({
    severity: z.enum(["critical", "alert", "general"]),
    type: z.enum([
      "deliveryNotAvailable",
      "deliveryToLimitedAreas",
      "deliveryZipSame",
      "enterFullDeliveryAddress",
      "serviceDownError",
      "server"
    ]),
    message: z.string().optional()
  })
});
const DeliveryLocationFormValuesSchema = z.object({
  warehouse: z.string(),
  country: z.string(),
  city: z.string(),
  state: z.string(),
  zipCode: z.string(),
  userSelectionDeliveryMethod: z.enum(["Local", "Nationwide", "Store-Pick-Up"]).optional(),
  errorConfig: ErrorSchema.optional()
});
const onSubmitSchema = z.function().args(DeliveryLocationFormValuesSchema).returns(
  z.union([z.promise(z.union([ErrorSchema, z.undefined()])), z.void()])
).optional();
const DeliveryLocationFormPropsSchema = z.object({
  data: DeliveryLocationDrawerDataSchema,
  onSubmit: onSubmitSchema,
  onClose: z.function().returns(z.void())
});
const DeliveryLocationDrawerPropsSchema = z.object({
  /** Controls the Drawer's open state */
  isOpen: z.boolean(),
  /** Function to call when the drawer is closed */
  onClose: z.function().returns(z.void()),
  /** Function to call when the drawer form is submitted */
  onSubmit: onSubmitSchema,
  /** Current value of the drawer input */
  zipCode: z.union([
    z.string(),
    z.literal(""),
    z.literal(0),
    z.literal(false),
    z.null(),
    z.undefined(),
    z.nan()
  ])
});
const DeliveryAddressFormValuesSchema = z.object({
  streetAddress: z.string(),
  aptSuiteUnitEtc: z.string(),
  zipCode: z.string()
});
const DeliveryAddressFormPropsSchema = z.object({
  data: DeliveryLocationDrawerDataSchema,
  onSubmit: onSubmitSchema
});
export {
  DeliveryAddressFormPropsSchema,
  DeliveryAddressFormValuesSchema,
  DeliveryLocationDrawerDataSchema,
  DeliveryLocationDrawerPropsSchema,
  DeliveryLocationFormPropsSchema,
  DeliveryLocationFormValuesSchema
};
